import { render, staticRenderFns } from "./CompanyInfo.vue?vue&type=template&id=4252b36b&scoped=true&"
import script from "./CompanyInfo.vue?vue&type=script&lang=js&"
export * from "./CompanyInfo.vue?vue&type=script&lang=js&"
import style0 from "./CompanyInfo.vue?vue&type=style&index=0&id=4252b36b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4252b36b",
  null
  
)

export default component.exports